module.exports = __webpack_public_path__ + "static/media/train.d36f0177.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/train.svg
// module id = 3681
// module chunks = 7